import { gql } from '@apollo/client';

const DELETE_PREREQUISITE_MUTATION = gql`
    mutation deletePrerequisiteSet( $input:DeletePrerequisiteSetInput! ){
        Result: deletePrerequisiteSet( input:$input ) {
            affectedRows
        }
    }
`;

export default DELETE_PREREQUISITE_MUTATION;
